<template>
  <pulse-card
    title="Filtros"
    subtitle="Defina a empresa e o período para carregar os tickets."
  >
    <template #actions>
      <pulse-button
        :label="mostrarFiltro ? 'Ocultar filtro' : 'Mostrar filtro'"
        :icon="mostrarFiltro ? 'pi pi-eye-slash' : 'pi pi-eye'"
        severity="secondary"
        outlined
        @click="alternarVisibilidade"
      />
    </template>

    <div
      v-if="mostrarFiltro"
      class="filtros-grid"
      :class="{ 'filtros-grid--sem-empresa': !empresa }"
    >
      <pulse-field v-if="modos.length > 0" label="Filtrar por">
        <pulse-select v-model="selectMode" :items="modos" />
      </pulse-field>

      <pulse-field v-if="empresa" label="Empresa">
        <pulse-select
          v-model="selectedCompany"
          :items="filteredEmpresas"
          item-text="text"
          item-value="value"
          placeholder="Selecione a empresa"
        />
      </pulse-field>

      <pulse-field v-if="!modoSemDataSelecionado" label="Data inicial">
        <pulse-date-picker
          v-model="localSelectedStartDateISO"
          @input="handleStartDateSelection"
        />
      </pulse-field>

      <pulse-field v-if="!modoSemDataSelecionado" label="Data final">
        <pulse-date-picker
          v-model="localSelectedEndDateISO"
          @input="handleEndDateSelection"
        />
      </pulse-field>

      <div class="filtros-acoes">
        <pulse-button
          label="Limpar"
          icon="pi pi-times"
          severity="secondary"
          outlined
          @click="limparFiltro"
        />
        <pulse-button
          label="Filtrar"
          icon="pi pi-filter"
          @click="filtrar"
        />
      </div>
    </div>
  </pulse-card>
</template>

<script>
import { toCompanyOptions } from "@/utils/companyDisplay";

export default {
  props: {
    modos: Array,
    tipos: Array,
    calendar: String,
    empresa: {
      type: Boolean,
      default: false,
    },
    previda: {
      type: Boolean,
      default: false,
    },
    modosSemData: {
      type: Array,
      default: () => [],
    },
  },

  created() {
    if (this.modos.length > 0) {
      this.selectMode = this.modos[0];
    }

    // Selecionar automaticamente a primeira empresa se houver apenas uma disponível
    this.$nextTick(() => {
      const empresasDisponiveis = this.filteredEmpresas;
      if (empresasDisponiveis.length === 1) {
        this.selectedCompany = empresasDisponiveis[0].value;
      }
    });

    if (this.calendar === null || this.calendar === "mes") {
      // Se calendar for null ou "mes", obtenha o primeiro dia do mês
      this.selectedStartDate = this.getFirstDayOfMonth();
    } else if (this.calendar === "decadas") {
      // Se calendar for "ano", obtenha o primeiro dia do ano
      this.selectedStartDate = this.getFirstDayOf60YearsAgo();
    } else if (this.calendar === "ano") {
      // Se calendar for "ano", obtenha o primeiro dia do ano
      this.selectedStartDate = this.getFirstDayOfYear();
    } else if (this.calendar === "quinzena") {
      this.selectedStartDate = this.getFirstDayOfMonth();
      this.selectedEndDate = this.getEndDateWithOffset(15);
    } else if (this.calendar === "dia") {
      const ontem = new Date();
      ontem.setDate(ontem.getDate() - 7);
      this.selectedStartDate = this.formatDateBR(ontem);
      this.selectedEndDate = this.formatDateBR(new Date());
    } else if (this.calendar === "colocacao_vaso") {
      // Sexta-feira da semana atual → quinta-feira da próxima semana
      const hoje = new Date();
      const diaSemana = hoje.getDay(); // 0=Dom ... 5=Sex, 6=Sáb
      const diasAteSexta = diaSemana <= 5 ? 5 - diaSemana : 6;
      const sexta = new Date(hoje);
      sexta.setDate(hoje.getDate() + diasAteSexta);
      const quinta = new Date(sexta);
      quinta.setDate(sexta.getDate() + 6);
      this.selectedStartDate = this.formatDateBR(sexta);
      this.selectedEndDate = this.formatDateBR(quinta);
    } else {
      // Se calendar for qualquer outro valor, obtenha o primeiro dia do mês por padrão
      this.selectedStartDate = this.getFirstDayOfMonth();
    }

    if (this.calendar !== "colocacao_vaso") {
      this.selectedEndDate = this.formatDateBR(new Date());
    }

    this.sincronizarDatasISO();
  },

  data() {
    return {
      mostrarFiltro: true,
      localSelectedEndDateISO: "",
      localSelectedStartDateISO: "",

      localSelectedEndDateISO2: "",
      localSelectedStartDateISO2: "",

      localSelectedEndDateISO3: "",
      localSelectedStartDateISO3: "",

      selectedStartDateISO: "",
      selectedEndDateISO: "",

      selectedStartDate: "",
      selectedEndDate: "",

      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,

      selectedCompany: null,
      selectedInf: "",
      selectMode: "",
      empresas: [
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE"
      ],
    };
  },

  computed: {
    modoSemDataSelecionado() {
      return this.modosSemData.includes(this.selectMode);
    },

    filteredEmpresas() {
      const empresas = this.previda
        ? [...this.empresas, "PREVIDA"]
        : this.empresas;

      return toCompanyOptions(empresas);
    },
  },

  methods: {
    alternarVisibilidade(valor) {
      // Se o valor for passado, define diretamente
      if (typeof valor === "boolean") {
        this.mostrarFiltro = valor;
      } else {
        // Senão, alterna normalmente
        this.mostrarFiltro = !this.mostrarFiltro;
      }
    },

    filtrar() {
      this.$emit("filtrar", {
        selectMode: this.selectMode,
        selectedStartDate: this.selectedStartDate,
        selectedEndDate: this.selectedEndDate,
        selectedOpcao: this.selectedOpcao,
        selectedInf: this.selectedInf,
        selectedCompany: this.selectedCompany,
      });
    },

    limparFiltro() {
      (this.selectedEndDate2 = ""),
        (this.selectedCompany = null),
        (this.selectedType = "Todos"),
        (this.selectedOpcao = "Todas"),
        (this.selectedProduto = "Todos"),
        (this.selectedInf = "");

      if (this.modos.length > 0) {
        this.selectMode = this.modos[0];
      }

      if (this.tipos.length > 0) {
        this.selectedType = this.tipos[0];
      }

      if (this.produtos.length > 0) {
        this.selectedProduto = this.produtos[0];
      }

      if (this.calendar === null || this.calendar === "mes") {
        // Se calendar for null ou "mes", obtenha o primeiro dia do mês
        this.selectedStartDate = this.getFirstDayOfMonth();
      } else if (this.calendar === "decadas") {
        // Se calendar for "ano", obtenha o primeiro dia do ano
        this.selectedStartDate = this.getFirstDayOf60YearsAgo();
      } else if (this.calendar === "ano") {
        // Se calendar for "ano", obtenha o primeiro dia do ano
        this.selectedStartDate = this.getFirstDayOfYear();
      } else if (this.calendar === "quinzena") {
        this.selectedStartDate = this.getFirstDayOfMonth();
        this.selectedEndDate = this.getEndDateWithOffset(15);
      } else if (this.calendar === "dia") {
        const ontem = new Date();
        ontem.setDate(ontem.getDate() - 1);
        this.selectedStartDate = this.formatDateBR(ontem);
        this.selectedEndDate = this.formatDateBR(new Date());
      } else {
        // Se calendar for qualquer outro valor, obtenha o primeiro dia do mês por padrão
        this.selectedStartDate = this.getFirstDayOfMonth();
      }

      this.selectedEndDate = this.formatDateBR(new Date());
      this.sincronizarDatasISO();
    },

    sincronizarDatasISO() {
      this.localSelectedStartDateISO = this.selectedStartDate
        ? this.convertToISO(this.selectedStartDate)
        : "";
      this.localSelectedEndDateISO = this.selectedEndDate
        ? this.convertToISO(this.selectedEndDate)
        : "";
    },

    handleStartDateSelection() {
      this.selectedStartDate = this.convertToBR(this.localSelectedStartDateISO);
      this.isStartDatePickerOpen = false;
    },

    handleEndDateSelection() {
      this.selectedEndDate = this.convertToBR(this.localSelectedEndDateISO);
      this.isEndDatePickerOpen = false;
    },

    handleStartDateSelection2() {
      this.selectedStartDate2 = this.convertToBR(
        this.localSelectedStartDateISO2
      );
      this.isStartDatePickerOpen2 = false;
    },

    handleEndDateSelection2() {
      this.selectedEndDate2 = this.convertToBR(this.localSelectedEndDateISO2);
      this.isEndDatePickerOpen2 = false;
    },

    handleStartDateSelection3() {
      this.selectedStartDate3 = this.convertToBR(
        this.localSelectedStartDateISO3
      );
      this.isStartDatePickerOpen3 = false;
    },

    handleEndDateSelection3() {
      this.selectedEndDate3 = this.convertToBR(this.localSelectedEndDateISO3);
      this.isEndDatePickerOpen3 = false;
    },

    convertToISO(dateString) {
      // Converte a data do formato "20/10/2023" para "2023-10-20"
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },

    convertToBR(dateString) {
      // Converte a data do formato ISO "2023-10-20" para "20/10/2023"
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    getFirstDayOfYear() {
      const dataAtual = new Date();
      const primeiroDiaDoAno = new Date(dataAtual.getFullYear(), 0, 1); // Janeiro é representado como 0
      return this.formatDateBR(primeiroDiaDoAno);
    },

    getEndDateWithOffset(offsetDays) {
      const dataAtual = new Date();
      const primeiroDiaDoAno = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      ); // Janeiro é representado como 0

      // Crie a variável endDate aqui
      const endDate = new Date(primeiroDiaDoAno);

      // Adicione o número de dias ao endDate
      endDate.setDate(endDate.getDate() + offsetDays);

      return this.formatDateBR(endDate);
    },

    getFirstDayOf60YearsAgo() {
      const dataAtual = new Date();
      const anoAtual = dataAtual.getFullYear();
      const ano60Atras = anoAtual - 60;
      const primeiroDiaDoAno60Atras = new Date(60, 0, 1); // Janeiro é representado como 0
      return this.formatDateBR(primeiroDiaDoAno60Atras);
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatDateUS(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${month}/${day}/${year}`;
    },

    convertToISO(dateString) {
      // Converte a data do formato "20/10/2023" para "2023-10-20"
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },

    convertToBR(dateString) {
      // Converte a data do formato ISO "2023-10-20" para "20/10/2023"
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style scoped>
.filtros-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
  align-items: end;
}

.filtros-grid > * {
  min-width: 0;
}

.filtros-acoes {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  justify-content: flex-end;
  gap: 8px;
  min-width: max-content;
}

@media (min-width: 640px) {
  .filtros-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1264px) {
  .filtros-grid {
    grid-template-columns: minmax(160px, 1fr) minmax(220px, 1.4fr) 170px 170px auto;
  }

  .filtros-grid--sem-empresa {
    grid-template-columns: minmax(0, 1fr) 170px 170px max-content;
  }
}

/* Certifique-se de que o arquivo CSS com a classe .custom-col esteja importado aqui */
.custom-col-13 {
  flex-basis: 13%;
  /* 15% é equivalente a 1.5 colunas em uma grade de 10 colunas */
  max-width: 13%;
}

.custom-col-15 {
  flex-basis: 15%;
  /* 15% é equivalente a 1.5 colunas em uma grade de 10 colunas */
  max-width: 15%;
}

.pulse-shared-filter {
  margin: 0;
  padding: 16px 16px 0;
}

.pulse-shared-filter__card {
  overflow: hidden;
  background: #fff !important;
}

.pulse-shared-filter__grid {
  margin: -8px;
}

.pulse-shared-filter__grid span {
  display: block;
  margin-bottom: 4px;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--pulse-muted);
}

.pulse-shared-filter__actions {
  justify-content: flex-end;
  gap: 8px;
  padding: 16px 0 0;
}

.pulse-filter-action {
  min-width: 92px !important;
  height: 36px !important;
  margin: 0 !important;
  border-radius: var(--pulse-radius) !important;
  box-shadow: none !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

@media (max-width: 599px) {
  .pulse-shared-filter {
    padding: 12px 12px 0;
  }

  .pulse-shared-filter__actions {
    flex-wrap: wrap;
  }
}
</style>
